import { Link } from "@opensea/next-ui-kit"
import { TextBody } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { TERMS_OF_SERVICE_URL } from "@/constants/constants"

export function PageFooterTermsOfService() {
  const t = useTranslations("PageFooterTermsOfService")

  return (
    <Link className="-mt-[4px]" href={TERMS_OF_SERVICE_URL} variant="unstyled">
      <TextBody color="text-secondary" size="xs">
        {t("termsOfService")}
      </TextBody>
    </Link>
  )
}
